/**
 * @packageDocumentation
 * @module HackerAPI.Event.MailingListSignup
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import { parseDate } from "../../utils/utils";
/**
 * A container for data related to a mailing list signup for an event.
 * @class
 * @extends { HackerAPI.Base }
 */
var MailingListSignup = /** @class */ (function (_super) {
    __extends(MailingListSignup, _super);
    /**
     * Creates a new MailingListSignup object
     * @param content
     */
    function MailingListSignup(_a) {
        var _b = _a === void 0 ? {} : _a, email = _b.email, id = _b.id, name = _b.name, created_at = _b.created_at, createdAt = _b.createdAt, already_signed_up = _b.already_signed_up, alreadySignedUp = _b.alreadySignedUp;
        var _this = _super.call(this, {
            id: Base.doNotSendHandler,
            alreadySignedUp: Base.doNotSendHandler
        }) || this;
        /**
         * The email signed up with
         * @type { string }
         */
        _this.email = email;
        /**
         *
         * @type { string }
         */
        _this.id = id;
        /**
         * The person's name
         * @type { string }
         */
        _this.name = name;
        /**
         * Whether or not this is a repeat signup
         * @type { boolean }
         */
        _this.alreadySignedUp = already_signed_up || alreadySignedUp;
        /**
         * When the person subscribed for the mailing list
         * @type { string }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        return _this;
    }
    /**
     * Gets the mailing list for an event
     * @param event - The event to sign up for
     * @param event.slug
     * @param token
     * @returns
     */
    MailingListSignup.fetchAll = function (_a, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/signups",
            method: "GET",
            token: token
        }).then(function (data) {
            return data.map(function (datum) { return new MailingListSignup(datum); });
        });
    };
    /**
     * Signs up a specified user for the mailing list of given event
     * @param event - The event to sign up for
     * @param event.slug - Slug of the event
     * @param signup
     * @param [signup.name] - Their name
     * @param signup.email - Their email
     * @returns
     */
    MailingListSignup.create = function (_a, signup) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/signups",
            method: "POST",
            body: signup.toHackerAPIFormat()
        }).then(function (data) { return new MailingListSignup(data); });
    };
    return MailingListSignup;
}(Base));
export default MailingListSignup;
//# sourceMappingURL=mailing-list-signup.js.map